
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import CartSvg from './svg/CartSvg.vue';

export default defineComponent({
  name: 'CartIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      CartSvg: markRaw(CartSvg)
    };
  }
});
